
































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import { ApexChartData, AvailableChartTypes, isApexChartType } from '@/chartHelper';

import { ResultSet, TimeDimensionGranularity } from '@cubejs-client/core';
import { QueryRenderer } from '@cubejs-client/vue';

import { ApexChartTransformer, dateFormater } from '@/chartHelper';
import { apiService, cubejsService } from '@/container';

import { DxDataGrid, DxToolbar, DxToolbarItem } from 'devextreme-vue/data-grid';
import { Column, Properties as DataGridProperties } from 'devextreme/ui/data_grid';

import CubeJsChart from './CubeJsChart.vue';
import { isArray, isNil } from 'lodash';
import { ApexOptions } from 'apexcharts';
import { tryTranslateCaption } from './resultSetTransform';

@Component({
	components: {
		CubeJsChart,
		QueryRenderer,
		DxDataGrid,
		VueApexCharts,
		DxToolbar,
		DxToolbarItem
	}
})
export default class ChartRender extends Vue {

	@Prop({ type: String }) idChart?: string;
	@Prop({ type: String, default: '350' }) height!: string | number;
	@Prop({ type: String, default: '100%' }) width!: string | number;
	@Prop({ type: Object }) resultSet?: ResultSet | null;
	@Prop({ type: String }) chartType?: AvailableChartTypes;
	@Prop({ type: String }) chartName?: string;
	@Prop({ type: Object }) config?: any | null;
	@Prop({ type: Object, default: () => ({}) }) chartProps!: Record<string, unknown>;
	@Prop({ type: Boolean, default: false }) groupingByWeek!: boolean;
	@Prop({ type: Object }) export?: Record<string, () => void>;

	readonly isApexChartType = isApexChartType;

	cubejsApi: any = null;
	chartHelper: ApexChartTransformer = new ApexChartTransformer();
	internalResultSet: ResultSet | null = null;
	internalChartType: AvailableChartTypes | null = null;
	internalChartData: any | null = null;
	internalChartName: string | null = null;
	internalConfig: any | null = null;
	legend: any[] | null = null;

	isLoadingChartOptions = true;
	internalChart: any = {};
	computedChartData: ApexChartData | null = null;
	defaultChartData: any = {
		options: {
			chart: {
				toolbar: {
					show: false
				},
				stacked: this.isStacked
			},
			xaxis: {
				labels: {
					trim: true
				}
			}
		}
	};
	defaultChartReadonlyOptions: ApexOptions = {
		chart: {
			toolbar: {
				show: true,
				offsetY: 5,
				tools: {
					download: true,
					selection: false,
					zoom: false,
					zoomin: false,
					zoomout: false,
					pan: false,
					reset: false,
					customIcons: []
				},
				export: {
					csv: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					},
					svg: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					},
					png: {
						filename: ((this.internalChart || {}).name) || 'EmptyName'
					}
				}
			},
			stacked: this.isStacked
		},
		title: {
			text: (this.internalChart || {}).name,
			style: {
				color: 'rgba(0, 143, 251, 0.85)',
				fontSize: '20px',
			}
		},
		xaxis: {
			labels: {
				trim: true
			}
		}
	}

	async created(): Promise<void> {
		this.$emit('update:reload', async () => await this.loadChartData());
		this.$watch(() => this.chartType, this.onChartTypeChange, { immediate: true });
		this.$watch(() => this.chartName, this.onChartNameChange, { immediate: true });

		this.$watch(() => this.internalChartType, this.onInternalChartTypeChange, { immediate: true });

		this.$watch(() => this.config, val => {
			this.internalConfig = val;
			// 	this.chartData();
		}, { immediate: true, deep: true });
		this.$watch(() => this.internalConfig, val => this.$emit('update:config', _.merge({}, this.config, val)));
		// this.$watch(() => this.internalChartData, () => {
		// 	if (this.chartType === 'pie')
		// 		this.onLegendUpdated(null);
		// });
	}

	getDefaultColorIndex(i) {
		const multiplier = Math.floor(i / 5);
		const subtraction = multiplier * 5;
		return i - subtraction;
	}

	defaultColor: string[] = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'];

	onLegendUpdated(val) {
		this.legend = val;
		let colorConfig: any = {};
		let legendWithColors = this.extractLegend(this.internalChartData);

		// if (this.chartType === 'pie') {
		// 	let colors = this.extractColors(this.internalChartData);
		// 	colorConfig.colors = legendWithColors.map((x, index) => ({
		// 		value: x,
		// 		fillColor: colors[index] ?? this.defaultColor[this.getDefaultColorIndex(index)]
		// 	}));
		// } else
		colorConfig.colors = this.chartType !== 'pie' ? legendWithColors : legendWithColors.map((x, index) => ({
			value: x.value,
			fillColor: legendWithColors[index].fillColor ?? this.defaultColor[this.getDefaultColorIndex(index)]
		}));


		/*
			Before merging config with colorConfig I need to merge config with { colors: null } in order to invalidate previous array
			In this way, if config has more color then colorConfig, I will get the correct merge back
		*/
		this.$emit('update:config', _.merge({}, this.config, { colors: null }, colorConfig));
	}

	async mounted() {
		// if (!this.withChartId) {
		// 	this.chartData();
		// }
	}

	extractLegend(val) {
		let legend: any[] = [];
		switch (this.chartType) {
			case 'pie':
			case 'bar':
			case 'line':
			case 'area':
			case 'radar':
				if (isNil(this.legend) || !isArray(this.legend) || this.legend.length === 0)
					return [];
				legend = this.legend.map(x => ({
					value: x.nameCode || x.name,
					fillColor: x.color,
					localeValue: x.name
				}));
				break;
			default:
				legend = [];
				break;
		}
		return legend;
	}

	extractColors(val) {
		let colors = [];
		switch (this.chartType) {
			case 'pie':
			case 'bar':
			case 'line':
			case 'area':
				if (!_.isNil(val) && !_.isNil(val.options) && !_.isNil(val.options.colors)
					&& _.isArray(val.options.colors) && val.options.colors.length > 0)
					colors = val.options.colors;
				break;
			default:
				colors = [];
				break;
		}
		return colors;
	}

	get withChartId() {

		return _.isString(this.idChart) && this.idChart.trim() !== '';
	}

	chartData(): any {
		this.chartHelper.setGroupedByWeek(this.groupingByWeek);
		const chartOptions = this.chartHelper.getChartData(this.chartType!, this.resultSet!, this.internalConfig);
		const result = {
			..._.merge(
				chartOptions
				, this.defaultChartData),
			...this.chartProps,
			height: this.height,
			width: this.width
		};

		this.internalChartData = result;
	}


	get readonlyChartProps() {
		if (!_.isNil(this.defaultChartReadonlyOptions)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export)
			&& !_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.csv)) {

			if (!_.isNil(this.internalChartName)) {
				this.defaultChartReadonlyOptions.chart.toolbar.export.csv.filename = this.internalChartName;

				if (!_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.png))
					this.defaultChartReadonlyOptions.chart.toolbar.export.png.filename = this.internalChartName;

				if (!_.isNil(this.defaultChartReadonlyOptions.chart.toolbar.export.svg))
					this.defaultChartReadonlyOptions.chart.toolbar.export.svg.filename = this.internalChartName;
			}

			if (!_.isNil(this.internalChartName) && !_.isNil(this.defaultChartReadonlyOptions.title))
				this.defaultChartReadonlyOptions.title.text = this.internalChartName;

			if (!_.isNil(this.chartQuery) && !_.isNil(this.chartQuery.dimensions) && _.isArray(this.chartQuery.dimensions)
				&& this.chartQuery.dimensions.length > 0)
				this.defaultChartReadonlyOptions.chart.toolbar.export.csv.headerCategory = this.$t(this.chartQuery.dimensions[0]);
		}
		return _.merge({}, this.defaultChartReadonlyOptions, this.chartProps);
	}

	get cubeJsChartConfig() {
		const additionalConfig = this.internalChart.additionalConfig;
		if (!_.isNil(additionalConfig))
			return JSON.parse(additionalConfig);
		return {};
	}
	loadInternalChartData(resultSet: ResultSet): any {

		this.chartHelper.setGroupedByWeek(this.internalChart.groupingByWeek);
		const additionalConfig = this.internalChart.additionalConfig;
		if (!_.isNil(additionalConfig))
			this.internalConfig = JSON.parse(additionalConfig);

		const chartOptions = this.chartHelper.getChartData(this.internalChart.type!, resultSet!, this.internalConfig);
		const filename = this.internalChart?.name ?? 'EmptyName';
		const result = {
			..._.merge(
				chartOptions,
				{
					options: {
						chart: {
							toolbar: {
								show: true,
								offsetY: 5,
								tools: {
									download: true,
									selection: false,
									zoom: false,
									zoomin: false,
									zoomout: false,
									pan: false,
									reset: false,
									customIcons: []
								},
								export: {
									csv: {
										filename
									},
									svg: {
										filename
									},
									png: {
										filename
									}
								}
							},
							stacked: this.isStacked
						},
						title: {
							text: (this.internalChart || {}).name,
							style: {
								color: 'rgba(0, 143, 251, 0.85)',
								fontSize: '20px',
							}
						},
						xaxis: {
							labels: {
								trim: true
							}
						}
					}
				}, {
				options: this.chartProps
			}),
			height: this.height,
			width: this.width
		};
		return result;
	}

	getTableProps(resultSet: ResultSet, editMode: boolean): DataGridProperties {
		const tableColumns = resultSet.tableColumns();
		const containDot = tableColumns.some(c => c.key.includes('.'));

		let dataSource: Array<Record<string, unknown>> = resultSet.tablePivot();

		const timeDimensions = this.getTimeDimensions();

		const columns: Column[] = tableColumns.map(c => ({
			dataField: c.key,
			// this conditional statement was added becouse CubeJs adds the granularity in the trailer
			// of the time dimension so this way everything is normalized and the caption can work
			caption: this.$t(c.type === 'time' ? c.key.replace('.' + timeDimensions.granularity, '') : c.key)
		}));

		if (containDot) {
			const normalizedColumns = tableColumns.reduce((acc, c) => ({
				...acc,
				[c.key]: c.key.includes('.') ? c.key.replaceAll('.', '_') : c.key
			}), {});

			for (const column of columns)
				column.dataField = normalizedColumns[column.dataField!];

			dataSource = dataSource.map(r => Object.entries(r)
				.reduce((acc, [k, v]) => ({ ...acc, [normalizedColumns[k]]: v }), {}));
		}
		dataSource.forEach((row) => {
			if (!_.isNil(timeDimensions.timeDimensionCode) && !_.isNil(timeDimensions.granularity) && !_.isNil(row[timeDimensions.timeDimensionCode]) && _.isString(row[timeDimensions.timeDimensionCode]))
				row[timeDimensions.timeDimensionCode] = dateFormater(new Date(row[timeDimensions.timeDimensionCode] as string), timeDimensions.granularity as TimeDimensionGranularity);

			Object.keys(row).forEach((column) => {
				if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/gm.test(row[column] as any) && column != timeDimensions.timeDimensionCode)
					row[column] = dateFormater(new Date(row[column] as string), 'second' as TimeDimensionGranularity);

				row[column] = tryTranslateCaption((row[column] as string), this.$t);
			});
		});
		return {
			columns,
			dataSource,
			filterRow: { visible: true },
			sorting: { mode: editMode ? 'none' : 'single' },
			paging: { enabled: true, pageSize: 20 },
			export: { enabled: false, fileName: this.internalChartName! },
			toolbar: { visible: !editMode, items: [{ template: 'chartName', location: 'before' }] },
			showColumnLines: true,
			height: this.height
		};
	}

	getTimeDimensions(): any {
		let query;
		let timeDimensionCode;
		let granularity: TimeDimensionGranularity;

		if (this.withChartId) {
			if (!_.isNil(this.internalChart) && !_.isNil(this.internalChart.query))
				query = this.chartQuery;
		} else {
			if (!_.isNil(this.resultSet))
				query = this.resultSet.query();
		}

		if (_.isNil(query) || !_.isArray(query.timeDimensions) || query.timeDimensions.length <= 0 || _.isNil(query.timeDimensions[0].granularity))
			return { timeDimensionCode: null, granularity: null };

		granularity = query.timeDimensions[0].granularity;
		timeDimensionCode = this.normalizeTimeDimentionCode(query.timeDimensions[0].dimension, granularity);

		return { timeDimensionCode: timeDimensionCode, granularity: granularity };
	}

	normalizeTimeDimentionCode(timeDimensionCode, granularity): string {
		return (!_.isNil(timeDimensionCode) && timeDimensionCode.includes('.')
			? timeDimensionCode = timeDimensionCode.replaceAll('.', '_') : timeDimensionCode) + '_' + granularity;
	}

	get chartQuery() {
		return JSON.parse(this.internalChart.query) || {};
	}

	get isStacked() {
		return !_.isNil(this.internalConfig) && !_.isNil(this.internalConfig.isStacked) && this.internalConfig.isStacked;
	}

	async loadChartData(): Promise<void> {
		this.isLoadingChartOptions = true;
		const chart = await apiService.get('charts', `${this.idChart}`);

		this.internalChart = chart;
		this.internalChartName = chart.name;
		// type assertion below must be removed after resultChartType method is removed
		this.internalChartType = this.internalChart.type as AvailableChartTypes;
		this.isLoadingChartOptions = false;
		this.cubejsApi = await cubejsService.cubejsApi(this.internalChart.idCustomer);
	}

	onChartTypeChange(): void {
		this.internalChartType = this.chartType === undefined ? null : this.chartType;
	}

	async onInternalChartTypeChange(): Promise<void> {
		if (this.internalChartType === 'table')
			this.$emit('update:export', {
				excel: () => {
					(this.$refs.dataGrid as any).$_instance.exportToExcel();
				}
			});
	}

	onChartNameChange(): void {
		this.internalChartName = this.chartName === undefined ? null : this.chartName;
	}

	@Watch('idChart', { immediate: true })
	async onIdChartChange(newValue: string | null) {
		if (_.isString(newValue) && newValue.trim() !== '')
			await this.loadChartData();
	}
}
